import defaultAxios from 'lib/axios'
import ReactRailsUJS from 'react_ujs'

const HOST_ID = 'package-modal-host'

function modalHost() {
  let host = document.getElementById(HOST_ID)
  if (!host) {
    host = document.createElement('div')
    host.id = HOST_ID
    document.body.appendChild(host)
  }
  return host
}

// Exposed so package modals can portal their content inside the host that openPackageModal/
// closePackageModal manage, instead of escaping to document.body.
export const getPackageModalHost = modalHost

// Bumped on every call so a slower, earlier request can tell it's been superseded once its
// fetch resolves -- otherwise two quick calls can resolve out of order and the stale one
// mounts over the modal a later call already opened.
let latestRequestId = 0

export async function openPackageModal(packageId, modalName, resourceId = null) {
  const path = resourceId
    ? `/packages/${packageId}/modals/${modalName}/${resourceId}`
    : `/packages/${packageId}/modals/${modalName}`
  const host = modalHost()
  const requestId = (latestRequestId += 1) // invalidate any earlier in-flight fetch as soon as this one starts
  const { data: html } = await defaultAxios.get(path, { headers: { Accept: 'text/html' } })
  if (requestId !== latestRequestId) return null // a newer call has since taken over the host
  const wrapper = new DOMParser().parseFromString(html, 'text/html').querySelector('.package-modal-wrapper')
  if (!wrapper) return null // keep whatever modal is already showing rather than blanking the host
  closePackageModal() // unmount the previous modal now that the new one is ready to replace it
  host.innerHTML = wrapper.innerHTML
  // react_ujs 3.x mounts the server-emitted data-react-class node and records its createRoot
  // root in ReactRailsUJS.roots, so unmountComponents can later tear it down correctly.
  ReactRailsUJS.mountComponents(host)
  return host
}

export function closePackageModal() {
  const host = document.getElementById(HOST_ID)
  if (!host) return
  latestRequestId += 1 // invalidate any in-flight openPackageModal fetch targeting this host
  // react_ujs 3.x calls the tracked root's unmount() (not the legacy no-op), so React effect
  // cleanups run -- e.g. Modal releasing the body 'overlay-activated' scroll lock (DOME-1223).
  // Run this before clearing the DOM so the nodes are still attached when React tears them down.
  ReactRailsUJS.unmountComponents(host)
  host.innerHTML = ''
}

// document_requirement.js/packages.js are Sprockets globals and can't import this module,
// so it must also hang off window for them to call, same as they already call bare swal(...).
window.openPackageModal = openPackageModal
window.closePackageModal = closePackageModal
